const mode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'development' : 'production'
export const configuration = window.GLOBAL_CONFIGURATION[mode]
export const API = mode === 'production' ? configuration.API_HOST[window.location.hostname] : configuration.API_HOST;
export const MUI_LICENSE_KEY = '5e6112a021dd7b28e217a41cf5318d20Tz02NzQ2NSxFPTE3MTY5NzgwMjUyMjgsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
export const Languages = {
    EL: 'el',
    EN: 'en',
}